import { Component } from '@angular/core';
import { App, Events} from 'ionic-angular';

import { User }   from '../../providers/user/user';
import { Utils }  from '../../providers/utils/utils';

import { Login }    from '../../pages/login/login';

/*
*
*  Disconnect Page
*
*/
@Component({
  selector: 'disconnect',
  templateUrl: 'disconnect.html'
})
export class Disconnect {

    constructor(  
        public utils: Utils,
        public user: User,
        private app: App,
        public events: Events
    ) {
        this.init();
    }

    init() {
        
        let that = this;
        that.utils.log('Disconnect::init()');
        that.events.publish('user:beforeDisconnect');
        setTimeout(function() {
            that.events.publish('iptv:off');
            that.user.disconnect().then( () => { 
                that.app.getRootNav().setRoot(Login); 
            }, (err) => {
                that.utils.error(err);
                that.app.getRootNav().setRoot(Login); 
            });
        },2500);
        
    }
}



// WEBPACK FOOTER //
// ./src/pages/disconnect/disconnect.ts